<script>
export default {
    name: "NotFound",
    computed: {
        logoUrl() {
            let savedLogo = this.$store.getters["reduxi/getSiteLogo"]

            if (savedLogo !== null && savedLogo.length > 0) {
                return savedLogo
            }

            return require(`@/assets/brands/${this.$brand}/images/logo.svg`)
        },
    },
}
</script>

<template>
    <div id="notFound">
        <img :src="logoUrl" class="center-block logo" />

        <div class="text-center col-sm-12">
            <h1>{{ $t("fallback.lost") }}</h1>
            <h4>{{ $t("fallback.missing_page") }}</h4>
            <router-link to="/" class="vertical-5p lead">{{ $t("fallback.home") }}</router-link>
        </div>
    </div>
</template>

<style>
#notFound {
    padding: 20px;
}
</style>
